(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('angular'), require('vue')) :
  typeof define === 'function' && define.amd ? define(['angular', 'vue'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.ngVue = factory(global.angular, global.Vue));
})(this, (function (angular, Vue) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var angular__default = /*#__PURE__*/_interopDefaultLegacy(angular);
  var Vue__default = /*#__PURE__*/_interopDefaultLegacy(Vue);

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var isEnvTestOrProduction = typeof process !== 'undefined' && typeof process.env !== 'undefined' && (process.env.BABEL_ENV === 'test' || process.env.NODE_ENV === 'production');
  var warn = typeof console !== 'undefined' && typeof console.warn === 'function' && !isEnvTestOrProduction ? console.warn.bind(console) : undefined;
  var logger = {
    warn: typeof warn === 'function' ? warn : function () {} // Default to a noop function

  };

  var pluginHooks = Object.create(null);
  var defaultHooks = ['beforeCreated', 'created', 'beforeMount', 'mounted', 'beforeUpdate', 'updated', 'beforeDestroy', 'destroyed'];
  var vueHooks = Object.create(null);

  function addHooks(map, hooks) {
    if (hooks) {
      Object.keys(hooks).forEach(function (h) {
        map[h] = map[h] ? map[h] : [];
        map[h].push(hooks[h]);
      });
    }
  }

  function callHooks(map, name, callback) {
    var hooks = map[name];

    if (hooks) {
      hooks.forEach(callback);
    }
  }

  function createVueHooksMap(hookCallback) {
    return Object.keys(vueHooks).reduce(function (available, name) {
      return _objectSpread2(_objectSpread2({}, available), {}, _defineProperty({}, name, function () {
        var _cb = hookCallback.bind(this);

        callHooks(vueHooks, name, _cb);
      }));
    }, {});
  }

  function ngVueProvider($injector) {
    var _this = this;

    var _inQuirkMode = false;
    var rootProps = {};

    this.activeQuirkMode = function () {
      _inQuirkMode = true;
    };

    this.enableVuex = function (store) {
      logger.warn('enableVuex() is deprecated and will be removed in a future release.\nConsider switching to setRootVueInstanceProps().');
      Object.assign(rootProps, {
        store: store
      });
    };
    /**
     * @param {props} Object with arbitrary properties to be added to the root Vue instance (i.e.,
     * Vuex's `store`, Vue i18n `i18n`, Vue Router's `router`, and so on)
     *
     * Usage:
     * import store from './store'
     * import i18n from './i18n'
     * import customProp './customVuePlugin'
     *
     * angular.module('app').config(($ngVueProvider) => {
     *   $ngVueProvider.setRootVueInstanceProps({
     *     store,
     *     i18n,
     *     customProp
     *   })
     * })
     *
     */


    this.setRootVueInstanceProps = function (props) {
      var hooksFound = Object.keys(props).filter(function (hookName) {
        return defaultHooks.includes(hookName);
      });
      hooksFound.forEach(function (hookName) {
        return delete props[hookName];
      });
      Object.assign(rootProps, props);
    };

    this.install = function (plugin) {
      var _plugin = plugin($injector),
          $name = _plugin.$name,
          $config = _plugin.$config,
          $plugin = _plugin.$plugin,
          $vue = _plugin.$vue;

      addHooks(pluginHooks, $plugin);
      addHooks(vueHooks, $vue);
      angular.extend(_this, _defineProperty({}, $name, $config));
    };

    this.$get = ['$injector', function ($injector) {
      var cb = function cb(hook) {
        hook($injector, Vue__default["default"],
        /* dynamic context */
        this);
      };

      callHooks(pluginHooks, 'init', cb); // Explicitly overwrite any hook defined with `setRootVueInstanceProps` so that
      // the current behavior is kept and no breaking changes are introduced.

      Object.assign(rootProps, createVueHooksMap(cb));
      return {
        getRootProps: function getRootProps() {
          return rootProps;
        },
        inQuirkMode: function inQuirkMode() {
          return _inQuirkMode;
        }
      };
    }];
  }

  angular__default["default"].module('ngVue.plugins', []).provider('$ngVue', ['$injector', ngVueProvider]);

  var registered = Object.create(null); // these string filters will be resolved by `$filter` service

  var lazyStringFilters = []; // add an ng filter function

  function addFilter(name, filter) {
    registered[name] = filter;
  } // resolve the strings with $injector


  function resolveStringFilters($injector) {
    var $filter = $injector.get('$filter');
    lazyStringFilters.forEach(function (name) {
      addFilter(name, $filter(name));
    });
    lazyStringFilters = [];
  } // register a list of ng filters to ngVue


  function registerFilters(filters) {
    if (angular.isArray(filters)) {
      lazyStringFilters = lazyStringFilters.concat(filters);
    } else if (angular.isObject(filters)) {
      Object.keys(filters).forEach(function (name) {
        addFilter(name, filters[name]);
      });
    }
  } // a Vue plugin will register the ng filters to Vue


  var ngFilters = function ngFilters(Vue) {
    var filterNames = Object.keys(registered);
    filterNames.forEach(function (name) {
      return Vue.filter(name, registered[name]);
    });
  }; // initialize all the ng filters and install the ngFilters plugin


  var onPluginInit = function onPluginInit($injector, Vue) {
    resolveStringFilters($injector);
    Vue.use(ngFilters);
  };

  var filters = angular__default["default"].module('ngVue.plugins').config(['$ngVueProvider', function ($ngVueProvider) {
    $ngVueProvider.install(function () {
      return {
        $name: 'filters',
        $config: {
          register: registerFilters
        },
        $plugin: {
          init: onPluginInit
        }
      };
    });
  }]);

  return filters;

}));
